<template>
	<!-- 安全统计 -->
	<div class="animate__animated animate__fadeIn" id="myChart" style="width: 80%;height: 700px;margin: auto;margin-top:2%;"></div>
</template>
<script>
var that;
import echarts from 'echarts';
import request from '@/utils/request';
export default {
	name: 'index',
	data() {
		return {
			legendData: [],
			seriesData: []
		};
	},
	mounted() {
		this.fnGetMapData();
		window.addEventListener('resize', this.chartResize);
	},
	methods: {
		chartResize() {
			this.myChart.resize();
		},
		// 获取今日考勤数据
		fnGetMapData() {
			request({
				url: 'exam/pxCount',
				method: 'GET'
			})
				.then(res => {
					if (res.data) {
						let _data = res.data;
						let _legend = [];
						let _series = [];
						for (let i in _data) {
							let _sum = _data[i].in + _data[i].not_in;
							let _value = _sum == 0 ? 0 : Math.ceil(parseFloat(_data[i]['in'] / _sum).toFixed(2) * 100);
							_legend.push(i);
							_series.push(_value);
						}
						this.legendData = _legend;
						this.seriesData = _series;
						this.$nextTick(() => {
							this.drawLine();
						});
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 初始化统计图
		drawLine() {
			var that = this;
			// 基于准备好的dom，初始化echarts实例
			this.myChart = this.$echarts.init(document.getElementById('myChart'));
			// 绘制图表
			this.myChart.setOption({
				title:{
					text: '统计培训率(%)',
					textStyle:{
						width: '100%',
						color: '#fff'
					}
				},
				color: {
					type: 'linear',
					x: 0,
					y: 0,
					x2: 0,
					y2: 1,
					colorStops: [
						{
							offset: 0,
							color: '#5fe3ff' // 0% 处的颜色
						},
						{
							offset: 1,
							color: '#0054b7' // 100% 处的颜色
						}
					],
					globalCoord: false // 缺省为 false
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						// 坐标轴指示器，坐标轴触发有效
						type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						data: this.legendData,
						axisTick: {
							alignWithLabel: true
						},
						axisLine: {
							lineStyle: {
								type: 'solid',
								color: '#fff',
								width: '2'
							}
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							},
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisLine: {
							lineStyle: {
								type: 'solid',
								color: '#fff',
								width: '2'
							}
						},
						axisLabel: {
							textStyle: {
								color: '#fff'
							},
							formatter: function(value,index){
								return value + '(%)'
							}
						}
					}
				],
				series: [
					{
						name: '培训率',
						type: 'bar',
						barWidth: '10%',
						data: this.seriesData,
						label:{
							normal:{
								show: true,
								formatter: '{c}%',
							},
						}
					}
				]
			});
		}
	}
};
</script>

<style>
#myChart >>> div {
	margin: 30px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/TotalTrain/totalTrainDefault/index.vue